/**
 * 语言字体配置
 * 每种语言对应一个字体包 key，字体包定义在 fontPackages 中
 */

/** 默认字体包 key */
export const DEFAULT_FONT_PACKAGE_KEY = 'default'

/**
 * 字体包定义
 * @type {Record<string, {
 *   fontFamily: string,
 *   fontFace?: {
 *     family: string,
 *     src: string,
 *     format?: string,
 *     weight?: string,
 *     style?: string,
 *     display?: string
 *   } | null
 * }>}
 */
export const fontPackages = {
  // 默认字体包：Inter + 系统中文字体（中文、英文共用）
  default: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', sans-serif",
    fontFace: {
      family: 'Inter',
      src: '@/assets/font/InterVariable.woff2',
      format: 'woff2',
      weight: '100 900',
      style: 'normal',
      display: 'swap'
    }
  },
  // 日文字体：仅 font-family，使用系统字体，无需加载字体包
  ja: {
    fontFamily: "'MS Gothic', 'ＭＳ ゴシック', 'MS ゴシック', 'Hiragino Sans', 'ヒラギノ角ゴシック', 'Noto Sans CJK JP', sans-serif",
    fontFace: null
  }
}

/**
 * 语言标识 -> 字体包 key
 * @type {Record<string, string>}
 */
export const localeFontMap = {
  'zh-CN': 'default',
  'en-US': 'default',
  'ja-JP': 'ja'
}

/**
 * 根据语言获取字体包 key
 * @param {string} lang - 语言标识 zh-CN / en-US / ja-JP
 */
export const getFontPackageKey = (lang) => localeFontMap[lang] || DEFAULT_FONT_PACKAGE_KEY

/**
 * 根据语言获取字体包配置
 * @param {string} lang - 语言标识 zh-CN / en-US / ja-JP
 */
export const getFontPackage = (lang) => {
  const packageKey = getFontPackageKey(lang)
  return fontPackages[packageKey] || fontPackages[DEFAULT_FONT_PACKAGE_KEY]
}

/**
 * 根据语言获取 font-family 字符串
 * @param {string} lang - 语言标识 zh-CN / en-US / ja-JP
 */
export const getLocaleFontFamily = (lang) => getFontPackage(lang).fontFamily

/** 页面字体 CSS 变量名 */
export const LOCALE_FONT_CSS_VAR = '--app-font-family'

/**
 * 根据当前语言应用字体与 html lang
 * @param {string} lang - 语言标识 zh-CN / en-US / ja-JP
 */
export const applyLocaleFont = (lang) => {
  const fontFamily = getLocaleFontFamily(lang)
  document.documentElement.lang = lang
  document.documentElement.style.setProperty(LOCALE_FONT_CSS_VAR, fontFamily)
  // 覆盖 Arco 主题写在 body 上的固定 font-family
  document.body.style.fontFamily = fontFamily
}
